<template>
  <rank-division-picker
    :type="'currentRank'"
    item-key="driveBoost"
    :title="$t('calculators_common.current_rank')"
    class="flex-5 flex-lg-10"
    :show-division="false"
    :show-server="true"
  />
  <DrivesPicker />
  <PlatformPicker />
  <OptionPicker />
  <ChampionsPicker />
  <RolesPicker :select-only-one-role="true" />
</template>
<script setup>
import RankDivisionPicker from "./pickers/RankDivisionPicker.vue";
import DrivesPicker from "./pickers/DrivesPicker.vue";
import PlatformPicker from "../commonpickers/PlatformPicker.vue";
import OptionPicker from "./pickers/OptionPicker.vue";
import ChampionsPicker from "../commonpickers/ChampionsPicker.vue";
import RolesPicker from "../lol/pickers/RolesPicker.vue";

const gameStore = useGameStore();
const checkoutStore = useCheckoutStore();

const handleDetails = () => {
  const rank = [...gameStore.getGameRanks].slice(1)[0];

  checkoutStore.clearCheckout();
  checkoutStore.setServer("52");

  checkoutStore.setPlatform({
    platform: 1,
  });
  checkoutStore.setDetails({
    currentRank: rank?.id,
    currentRankTitle: rank?.title,
    currentDrive: 0,
    desiredDrive: 5000,
  });
  checkoutStore.setGameAndPack({
    game: gameStore.getGame.id,
    pack: gameStore.getGamePack.id,
    fullGame: gameStore.getGame,
    fullPack: gameStore.getGamePack,
  });
};
handleDetails();

onNuxtReady(() => {
  checkoutStore.setCalculating();
});
</script>
